import { z } from 'zod';

export const COIN_FACE_VALUE_CENTS = 1;
export const PURCHASE_MARKUP_BPS = 3000;
export const FREE_TIER_REDEMPTION_SPLIT_BPS = 2000;

export const COIN_PACKAGES = [
  { coins: 100, priceCents: 130 },
  { coins: 500, priceCents: 650 },
  { coins: 1_000, priceCents: 1_300 },
  { coins: 2_000, priceCents: 2_600 },
  { coins: 5_000, priceCents: 6_500 },
  { coins: 10_000, priceCents: 13_000 },
] as const;

export type CoinPackage = (typeof COIN_PACKAGES)[number];

export const StreamerTier = z.enum(['free', 'paid']);
export type StreamerTier = z.infer<typeof StreamerTier>;

export interface RedemptionSplit {
  faceValueCents: number;
  streamerNetCents: number;
  platformCutCents: number;
}

export function computeRedemptionSplit(coins: number, tier: StreamerTier): RedemptionSplit {
  const faceValueCents = coins * COIN_FACE_VALUE_CENTS;
  if (tier === 'paid') {
    return { faceValueCents, streamerNetCents: faceValueCents, platformCutCents: 0 };
  }
  const platformCutCents = Math.floor((faceValueCents * FREE_TIER_REDEMPTION_SPLIT_BPS) / 10_000);
  return {
    faceValueCents,
    streamerNetCents: faceValueCents - platformCutCents,
    platformCutCents,
  };
}

export const LedgerEntryType = z.enum([
  'purchase',
  'tip_sent',
  'tip_received',
  'alert_purchase_sent',
  'alert_purchase_received',
  'pack_purchase_sent',
  'pack_purchase_received',
  'refund',
  'admin_adjust',
]);
export type LedgerEntryType = z.infer<typeof LedgerEntryType>;
